"use client";

import React from "react";
import { ChevronDown } from "lucide-react";

export interface FAQItem {
  question: string;
  answer: string | string[];
}

interface FAQAccordionProps {
  items: FAQItem[];
  expandedIndex: number;
  onToggle: (index: number) => void;
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({
  items,
  expandedIndex,
  onToggle,
}) => {
  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const isExpanded = expandedIndex === index;

        return (
          <details
            key={index}
            open={isExpanded}
            className="group"
            onToggle={(e) => {
              // Only handle open events to avoid double-toggling
              if ((e.target as HTMLDetailsElement).open && !isExpanded) {
                onToggle(index);
              } else if (!(e.target as HTMLDetailsElement).open && isExpanded) {
                onToggle(-1);
              }
            }}
          >
            <summary
              className="flex items-center justify-between cursor-pointer list-none p-4 rounded-lg bg-gray-800/30 border border-gray-700/50 hover:bg-gray-800/50 hover:border-gray-600/50 transition-all"
              onClick={(e) => {
                e.preventDefault();
                onToggle(isExpanded ? -1 : index);
              }}
            >
              <span className="text-white font-medium pr-4">{item.question}</span>
              <ChevronDown
                className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${
                  isExpanded ? "rotate-180" : ""
                }`}
              />
            </summary>

            <div
              className={`overflow-hidden transition-all duration-200 ${
                isExpanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <div className="p-4 pt-3 text-gray-300">
                {Array.isArray(item.answer) ? (
                  <ul className="list-disc list-inside space-y-1">
                    {item.answer.map((line, i) => (
                      <li key={i}>{line}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{item.answer}</p>
                )}
              </div>
            </div>
          </details>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
